import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {UserService, User, UserStatus} from './user.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(private us: UserService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const roles = route.data['roles'] as Array<string>;
    const currentUser = this.us.currentUser.getValue();
    if (currentUser) {
      return Observable.from([this.validateUser(currentUser, roles, route)]);
    }
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    if (username && token) {
      console.log(`User not logged, trying to login the user...`);
      return this.us.findById(username).map((user: User) => {
        return this.validateUser(user, roles, route);
      }).catch((e) => {
        console.log(`received ${e}`);
        this.router.navigateByUrl('/login');
        return Observable.of(false);
      }).first();
    } else {
      console.log(`User is not logged redirecting to Login Page...`);
      this.router.navigateByUrl('/login');
    }
  }

  validateUser(user: User, roles: Array<string>, route: ActivatedRouteSnapshot): boolean {
    console.log(`validating user ${JSON.stringify(user)} on roles ${JSON.stringify(roles)}`);
    console.log(`route:${JSON.stringify(route.url)}`);
    let found = false;
    if (user) {
      if (this.us.loginStatus.getValue() && this.us.loginStatus.getValue().status === UserStatus.NEED_CHANGE_PASS) {
        if (route && route.url && route.url[0]) {
          const path = route.url[0].path;
          if (path === 'changePass') {
            return true
          }
        }
        console.log(`User need to change password, redirecting...`);
        this.router.navigateByUrl('/changePass');
        return false;
      }
      if (user.roles.indexOf('ROOT') !== -1) {
        // console.log(`User ROLES: ${JSON.stringify(user.roles)} index: ${user.roles.indexOf(Roles.ROOT)}`);
        return true;
      }
      found = roles.some((role) => {
        if (user.roles.indexOf(role) !== -1) {
          return true;
        }
      });
    } else {
      console.log(`User not logged in trying to login`);
      this.router.navigateByUrl('/login');
      return false;
    }
    if (found) {
      return true;
    } else {
      return (roles.indexOf('ANY') !== -1);
    }
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/role-guard.service.ts